export function hasTable(html) {
  return /<table[\s>]/i.test(html) || /<(tr|td|th|colgroup|col)\b/i.test(html)
}
